import { useCallback } from "react";
import { useQuery } from "react-query";
import { ReferralApi } from "@jti/rest-api";
import { setReferralStatus, useDispatch, useSelector } from "@jti/store";
export const useSyncReferralStatus = () => {
    const dispatch = useDispatch();
    const isReferralOn = useSelector((state) => state.loyaltyCore.isReferralOn);
    const syncReferralStatus = useCallback((data) => {
        if (data != null) {
            const referralStatus = Boolean(data);
            if (isReferralOn !== referralStatus) {
                dispatch(setReferralStatus(referralStatus));
            }
        }
    }, [isReferralOn, dispatch]);
    return useQuery("ReferralApi.getStatus", () => ReferralApi.init().getStatus(), {
        initialData: null,
        onSuccess: syncReferralStatus,
    });
};
//# sourceMappingURL=useSyncReferralStatus.js.map